var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.334 6H2.33398C2.33398 5.06812 2.33398 4.60218 2.48622 4.23463C2.68921 3.74458 3.07856 3.35523 3.56861 3.15224C3.93616 3 4.4021 3 5.33398 3H19.334C20.2659 3 20.7318 3 21.0994 3.15224C21.5894 3.35523 21.9788 3.74458 22.1818 4.23463C22.334 4.60218 22.334 5.06812 22.334 6Z",
    stroke: "#2B52D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.334 6V21M2.33398 6V21",
    stroke: "#2B52D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.334 19V21M8.33398 19V21",
    stroke: "#2B52D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83398 14L8.07652 13.0299C8.4403 11.5747 8.62219 10.8472 9.16471 10.4236C9.70723 10 10.4572 10 11.9571 10H12.7109C14.2108 10 14.9607 10 15.5033 10.4236C16.0458 10.8472 16.2277 11.5747 16.5915 13.0299L16.834 14",
    stroke: "#2B52D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.334 14H7.33398C6.7817 14 6.33398 14.4477 6.33398 15V18C6.33398 18.5523 6.7817 19 7.33398 19H17.334C17.8863 19 18.334 18.5523 18.334 18V15C18.334 14.4477 17.8863 14 17.334 14Z",
    stroke: "#2B52D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83398 16.49V16.5",
    stroke: "#2B52D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.834 16.49V16.5",
    stroke: "#2B52D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarParking);
export default __webpack_public_path__ + "static/media/car-parking.6f3a1fa69491e5000bcb3a61c759e694.svg";
export { ForwardRef as ReactComponent };